import Constant from '@/common/constant/Constant';
import { Chip, MenuItem, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { memo, useEffect, useState } from 'react';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { useRecoilValue } from 'recoil';
import { userAtom } from '@/state/atom/userAtom';
import Utils from '@/common/utils/utils';
import {
    checkIsDisplayAddPermissions,
    handleAdditionalViewByViewPermissions,
    initDefaultPermissions,
    initListOptionAdditionalEditPermission,
    initListOptionEditPermission,
    initListOptionViewPermission,
    IN_PROJECT_PERMISSION_ITEM,
    initListOptionChatPermission,
    getListOptionChatPermissionsByViewPermisstion,
    getDisplayNamePermissionByValue,
    filterEditPermissionsByViewPermissions
} from '../handler/SettingPermissionHandler';
import { projectInuseDetailAtom, projectListInCorporationAtom } from '@/state/atom/projectAtom';
import './SettingPermissionKnowledgeTicket.css';
import AlertDialog from './AlertDialog';
import LoadingPanel from '@/component/common/LoadingPanel';
import {
    getListActiveB2BCustomerSelector,
    getListActiveB2BHelpdeskSelector
} from '@/state/selector/ticketSelector';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { disabledAllField } from '../handler/KnowledgeTicketHandler';
import { isDisplaySettingSynonymSearch } from '@/component/formManagement/handler/FormListHandler';
import { PropTypes } from 'prop-types';

SettingPermissionKnowledgeTicket.propTypes = {
    parentScreen: PropTypes.any,
    detailTicket: PropTypes.any,
    selectedFormDetail: PropTypes.any,
    dataSettingDefaults: PropTypes.any,
    viewPermissions: PropTypes.any,
    setViewPermissions: PropTypes.any,
    editPermissions: PropTypes.any,
    setEditPermissions: PropTypes.any,
    additionalViewPermissions: PropTypes.any,
    setAdditionalViewPermissions: PropTypes.any,
    additionalEditPermissions: PropTypes.any,
    setAdditionalEditPermissions: PropTypes.any,
    chatPermission: PropTypes.any,
    setChatPermission: PropTypes.any,
    API: PropTypes.any,
    reloadAfterCloseCSv: PropTypes.any,
    displayMode: PropTypes.any,
    hasEditSettingPermissions: PropTypes.any,
    panelList: PropTypes.any,
    tabId: PropTypes.any,
    handleStatus: PropTypes.any
};

function SettingPermissionKnowledgeTicket(props) {
    // Re-render when the translation dictionary loads/extends so tr() group headers update.
    useTranslationSubscription();

    const {
        parentScreen,
        detailTicket,
        selectedFormDetail,
        dataSettingDefaults,
        viewPermissions,
        setViewPermissions,
        editPermissions,
        setEditPermissions,
        additionalViewPermissions,
        setAdditionalViewPermissions,
        additionalEditPermissions,
        setAdditionalEditPermissions,
        chatPermission,
        setChatPermission,
        displayMode
    } = props;

    const [isLoading, setIsLoading] = useState(false);
    const userDetail = useRecoilValue(userAtom);
    const listProjectInCorp = useRecoilValue(projectListInCorporationAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);

    const listB2BCustomerRecoilState = useRecoilValue(getListActiveB2BCustomerSelector);
    const listB2BHelpdeskRecoilState = useRecoilValue(getListActiveB2BHelpdeskSelector);
    const [listB2BCustomer, setListB2BCustomer] = useState([]);
    const [listB2BHelpdesk, setListB2BHelpdesk] = useState([]);

    const [listOptionViewPermission, setListOptionViewPermission] = useState([]);
    const [listOptionEditPermission, setListOptionEditPermission] = useState([]);
    const [listOptionAdditionalOrigin, setListOptionAdditionalOrigin] = useState([]);
    const [listOptionAdditionalViewPermission, setListOptionAdditionalViewPermission] = useState(
        []
    );
    const [listOptionAdditionalEditPermission, setListOptionAdditionalEditPermission] = useState(
        []
    );
    const [isDisplayAdditionalPermission, setIsDisplayAdditionalPermission] = useState(false);

    const [isOpenAlertDialog, setIsOpenAlertDialog] = useState(false);

    const [isShowSettingPermission, setIsShowSettingPermission] = useState(false);

    const [listOptionChatPermission, setListOptionChatPermission] = useState([]);

    let argsAll = {
        API: props?.API,
        isLoading,
        setIsLoading,
        listProjectInCorp,
        projectInuseDetail: projectInuseDetail,
        corporationDetail,
        projectId: projectInuseDetail.id,
        userDetail: userDetail,
        parentScreen,
        selectedFormDetail,
        detailTicket,
        listB2BCustomerRecoilState,
        listB2BHelpdeskRecoilState,
        listB2BCustomer,
        setListB2BCustomer,
        listB2BHelpdesk,
        setListB2BHelpdesk,

        viewPermissions,
        setViewPermissions,
        editPermissions,
        setEditPermissions,
        chatPermission,
        setChatPermission,
        additionalViewPermissions,
        setAdditionalViewPermissions,
        additionalEditPermissions,
        setAdditionalEditPermissions,

        listOptionViewPermission,
        setListOptionViewPermission,
        listOptionEditPermission,
        setListOptionEditPermission,
        listOptionAdditionalOrigin,
        setListOptionAdditionalOrigin,
        listOptionAdditionalViewPermission,
        setListOptionAdditionalViewPermission,
        listOptionAdditionalEditPermission,
        setListOptionAdditionalEditPermission,
        listOptionChatPermission,
        setListOptionChatPermission,
        ...props
    };

    useEffect(() => {
        if (
            !Utils.isEmptyObject(dataSettingDefaults) &&
            !Utils.isEmptyArray(dataSettingDefaults?.viewPermission)
        ) {
            initListOptionViewPermission(argsAll);
        } else {
            setListOptionViewPermission([]);
        }
    }, [dataSettingDefaults, detailTicket]);

    useEffect(() => {
        if (
            !Utils.isEmptyObject(dataSettingDefaults) &&
            !Utils.isEmptyArray(dataSettingDefaults?.viewPermission)
        ) {
            setIsLoading(true);
            initDefaultPermissions(argsAll, dataSettingDefaults).then(() => {
                setIsLoading(false);
            });
        }
    }, [dataSettingDefaults, listProjectInCorp]);

    useEffect(() => {
        checkIsDisplayAddPermissions(viewPermissions, setIsDisplayAdditionalPermission);
    }, [viewPermissions]);

    useEffect(() => {
        if (props?.parentScreen === 'EditTicket') {
            return;
        }
        setListOptionViewPermission([]);
        setListOptionEditPermission([]);
        setListOptionAdditionalOrigin([]);
        setListOptionAdditionalViewPermission([]);
        setListOptionAdditionalEditPermission([]);
        setIsDisplayAdditionalPermission(false);
        setIsShowSettingPermission(false);
    },[
        props?.reloadAfterCloseCSv
    ])

     const onChangeViewPermission = (_, viewPermission) => {
        if (Utils.isEmptyArray(viewPermission)) {
            setIsOpenAlertDialog(true);
            return;
        }
        argsAll.setIsEdited(true);
        if (typeof argsAll.setIsEditTicket === 'function') {
            argsAll.setIsEditTicket(true);
        }
         

        setViewPermissions(viewPermission);
        initListOptionEditPermission(viewPermission, setListOptionEditPermission);
        initListOptionChatPermission(viewPermission, setListOptionChatPermission);

        setEditPermissions(filterEditPermissionsByViewPermissions(viewPermission, editPermissions));

        showChatPermissions(viewPermission);
        handleAdditionalViewByViewPermissions(argsAll, viewPermission, listOptionAdditionalOrigin);
        setAdditionalViewPermissions([]);
        setAdditionalEditPermissions([]);
        setListOptionAdditionalEditPermission([]);
    };

    const showChatPermissions = (viewPermission) => {
        let currentChatPermission = getDisplayNamePermissionByValue(chatPermission);
        let listNameViewPermission = [];
        for (const viewData of viewPermission) {
            listNameViewPermission.push(viewData?.displayName);
        }
        
        let chatPermissions = getListOptionChatPermissionsByViewPermisstion(listNameViewPermission)
        if (!Utils.isEmptyArray(chatPermissions) && 
            !chatPermissions.includes(currentChatPermission)) {
           setChatPermission(IN_PROJECT_PERMISSION_ITEM.value);
        }
    }

    const onChangeEditPermission = (_, permissions) => {
        if (Utils.isEmptyArray(permissions)) {
            setIsOpenAlertDialog(true);
            return;
        }
        argsAll.setIsEdited(true);
        if (typeof argsAll.setIsEditTicket === 'function') {
            argsAll.setIsEditTicket(true);
        }

        setEditPermissions(permissions);
    };

    const onChangeAdditionalViewPermission = (_, permissions) => {
        argsAll.setIsEdited(true);
        if (typeof argsAll.setIsEditTicket === 'function') {
            argsAll.setIsEditTicket(true);
        }

        setAdditionalViewPermissions(permissions);
        initListOptionAdditionalEditPermission(permissions, setListOptionAdditionalEditPermission);
        
        // Filter existing edit permissions to keep only those still in view permissions
        const filteredEditPermissions = additionalEditPermissions.filter(editPerm => 
            permissions.some(viewPerm => viewPerm?.id === editPerm?.id)
        );
        setAdditionalEditPermissions(filteredEditPermissions);
    };

    const onChangeAdditionalEditPermission = (_, permissions) => {
        argsAll.setIsEdited(true);
        if (typeof argsAll.setIsEditTicket === 'function') {
            argsAll.setIsEditTicket(true);
        }

        setAdditionalEditPermissions(permissions);
    };

    const filterSuggestionOption = createFilterOptions({
        ignoreCase: false,
        stringify: option => `${option.displayName}`
    });

    const filterSuggestionForAdditionalPermission = createFilterOptions({
        ignoreCase: false,
        stringify: option => `${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, option?.name)}`
    });

    const onChangeChatPermission = e => {
        argsAll.setIsEdited(true);
        if (typeof argsAll.setIsEditTicket === 'function') {
            argsAll.setIsEditTicket(true);
        }

        let chatPermissionValue = e.target.value;
        setChatPermission(chatPermissionValue);
    };

    const onDeleteAdditionalViewPermission = selectedOption => {
        if(!Utils.isEmptyString(argsAll?.detailTicket?.deletedAt)){
            return;
        }
        let newPermissions = additionalViewPermissions.filter(option => {
            return option?.id !== selectedOption?.id;
        });
        setAdditionalViewPermissions(newPermissions);

        // Update edit options based on new view permissions
        initListOptionAdditionalEditPermission(newPermissions, setListOptionAdditionalEditPermission);
        
        // Also remove from edit permissions if exists
        let newEditPermissions = additionalEditPermissions.filter(option => {
            return option?.id !== selectedOption?.id;
        });
        setAdditionalEditPermissions(newEditPermissions);
        
        argsAll.setIsEdited(true);
        if (typeof argsAll.setIsEditTicket === 'function') {
            argsAll.setIsEditTicket(true);
        }
    };

    const onDeleteAdditionalEditPermission = selectedOption => {
        if(!Utils.isEmptyString(argsAll?.detailTicket?.deletedAt)){
            return;
        }
        let newPermissions = additionalEditPermissions.filter(option => {
            return option.id !== selectedOption.id;
        });
        setAdditionalEditPermissions(newPermissions);
        argsAll.setIsEdited(true);
        if (typeof argsAll.setIsEditTicket === 'function') {
            argsAll.setIsEditTicket(true);
        }
    };

    const filterCorporationBlockAndDelete = (listOption) =>{
        return listOption?.filter((option)=>{
            return option && option?.name && option.corpActive !== Constant.CORPORATION_ACTIVE.BLOCK && option.corpActive !== Constant.CORPORATION_ACTIVE.DELETED
        })
    }

    const getSortedOptionsByGroupLabel = (listOption) => {
        const GROUP_ORDER = {
            'orgProject': 1,
            'b2bCustomerProject': 2,
            'b2bHelpdeskProject': 3,
            'other': 4
        };
        
        return filterCorporationBlockAndDelete(listOption)?.sort((a, b) => {
            const orderA = GROUP_ORDER[a?.groupId] || 999;
            const orderB = GROUP_ORDER[b?.groupId] || 999;
            return orderA - orderB;
        });
    };

    const handleDeleteViewPermission = selectedOption => {
        let newSelectViewPermissions = viewPermissions.filter(option => {
            return option !== selectedOption;
        });
        setViewPermissions([...newSelectViewPermissions]);
        argsAll.setIsEdited(true);
        if (typeof argsAll.setIsEditTicket === 'function') {
            argsAll.setIsEditTicket(true);
        }
        
        initListOptionEditPermission([...newSelectViewPermissions], setListOptionEditPermission);
        initListOptionChatPermission([...newSelectViewPermissions], setListOptionChatPermission);
        
        setEditPermissions(filterEditPermissionsByViewPermissions([...newSelectViewPermissions], editPermissions));
        showChatPermissions([...newSelectViewPermissions]);
        handleAdditionalViewByViewPermissions(argsAll, [...newSelectViewPermissions], listOptionAdditionalOrigin);
        setAdditionalViewPermissions([]);
        setAdditionalEditPermissions([]);
        setListOptionAdditionalEditPermission([]);
    };

    const handleDeleteEditPermission = selectedOption => {
        let newSelectEditPermissions = editPermissions.filter(option => {
            return option !== selectedOption;
        });
        setEditPermissions([...newSelectEditPermissions]);
        argsAll.setIsEdited(true);
        if (typeof argsAll.setIsEditTicket === 'function') {
            argsAll.setIsEditTicket(true);
        }
    };

    const currentDisplayMode = displayMode || Constant.DISPLAY_MODE.EDIT;
    const isEditMode = currentDisplayMode === Constant.DISPLAY_MODE.EDIT;

    const getDisableInput = () => {
        return (
            !props.hasEditSettingPermissions ||
            !Utils.isEmptyString(argsAll?.detailTicket?.deletedAt) ||
            disabledAllField(props.panelList, props.tabId, props.handleStatus) ||
            currentDisplayMode === Constant.DISPLAY_MODE.VIEW
        );
    };
    const disabled = getDisableInput();

    // Base project / guest customer project names are system-defined and should be translated,
    // while other project names (user-defined) must keep their original text.
    const getAdditionalPermissionName = option => {
        const projectName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, option?.name);
        if (
            option?.type === Constant.PROJECT_TYPE.BASE ||
            option?.type === Constant.PROJECT_TYPE.CUSTOMER
        ) {
            return tr(projectName);
        }
        return projectName;
    };

    return (
        <>
            {props.hasEditSettingPermissions ? (
                <>
                    {/* Header */}
                    <div
                        className="accordionHead-SettingTitle detail-knowledge-permission"
                        onClick={() => setIsShowSettingPermission(prev => !prev)}
                        >
                        <img src="/assets/image/setting-title.svg" alt="setting-title" />
                        <span className="text">{tr('属性設定')}</span>
                        {isShowSettingPermission ? (
                            <img src="/static/media/icon-minus-accordion.24e40269.svg" alt="minus" />
                        ) : (
                            <img src="/static/media/icon-plus-accordion.d9a73563.svg" alt="plus" />
                        )}
                    </div>
                    
                    {props.hasEditSettingPermissions && (
                        <>
                            {/*  View-Edit Permission Setting */}
                            <div className={`${isShowSettingPermission ? 'setting-permission-body' : 'setting-permission-body-none'}`}>
                                <LoadingPanel isLoading={isLoading} />
                                <div className="setting-permission-title">
                                    {tr('■ ナレッジチケットの閲覧権限・編集権限設定')}
                                </div>

                                <div className="setting-permission-wrap">
                                    <label className="setting-permission-label">{tr('基本閲覧権限')}</label>
                                    <div className={`setting-permission-input ${disabled ? 'class_disabled': 'enable-autoComplete'}`}>
                                        <Autocomplete
                                            className="setting-permission-tag-content"
                                            multiple
                                            disableClearable
                                            filterSelectedOptions={true}
                                            filterOptions={filterSuggestionOption}
                                            getOptionLabel={option => `${tr(option?.displayName)}`}
                                            getOptionSelected={(option, selected) =>
                                                option.value === selected.value
                                            }
                                            options={listOptionViewPermission}
                                            value={viewPermissions}
                                            onChange={onChangeViewPermission}
                                            disabled={disabled || (isDisplaySettingSynonymSearch(corporationDetail, selectedFormDetail?.type || detailTicket?.usage, projectInuseDetail) && (detailTicket ? detailTicket?.isSynonym : selectedFormDetail?.isSynonym))}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    className="form-control"
                                                    onKeyDown={event => {
                                                        if (event.key === 'Backspace') event.stopPropagation();
                                                    }}
                                                />
                                            )}
                                            renderTags={valueTag => {
                                                return valueTag.map((selecedOption, index) => {
                                                    return [
                                                        Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.CREATOR,
                                                        Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.IN_PROJECT
                                                        ].includes(selecedOption.displayName) ? (
                                                        <Chip 
                                                            key={index}
                                                            label={tr(selecedOption.displayName)}
                                                            className="MuiChip-root setting-title"
                                                            // deleteIcon={true}
                                                        />
                                                    ) : (
                                                        <Chip
                                                            key={index}
                                                            label={tr(selecedOption.displayName)}
                                                            className="MuiChip-root setting-title"
                                                            onDelete={isEditMode ? (e => {
                                                                valueTag.length > 1
                                                                    ? handleDeleteViewPermission(selecedOption)
                                                                    : setIsOpenAlertDialog(true);
                                                            }) : undefined}
                                                        />
                                                    );
                                                });
                                            }}
                                            ListboxProps={{	
                                                style: {	
                                                    maxHeight: 376,	
                                                    overflow: 'auto',	
                                                    overflowX: 'hidden'	
                                                }	
                                            }}
                                            noOptionsText={trI18n('COMMSG001')}
                                        />
                                    </div>
                                </div>

                                <div className="setting-permission-wrap">
                                    <label className="setting-permission-label">{tr('基本編集権限')}</label>
                                    <div className={`setting-permission-input ${disabled ? 'class_disabled': 'enable-autoComplete'}`}>
                                        <Autocomplete
                                            className="setting-permission-tag-content"
                                            multiple
                                            disableClearable
                                            filterSelectedOptions={true}
                                            filterOptions={filterSuggestionOption}
                                            getOptionLabel={option => `${tr(option?.displayName)}`}
                                            getOptionSelected={(option, selected) =>
                                                option.value === selected.value
                                            }
                                            options={listOptionEditPermission}
                                            value={editPermissions}
                                            onChange={onChangeEditPermission}
                                            disabled={disabled}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    className="form-control"
                                                    onKeyDown={event => {
                                                        if (event.key === 'Backspace') event.stopPropagation();
                                                    }}
                                                />
                                            )}
                                            renderTags={valueTag => {
                                                return valueTag.map((selecedOption, index) => {
                                                    return [
                                                            Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.CREATOR_ONLY,
                                                            Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.PROJECT_MANAGER
                                                        ].includes(selecedOption.displayName) ? (
                                                        <Chip
                                                            key={index}
                                                            label={tr(selecedOption.displayName)}
                                                            className="MuiChip-root setting-title"
                                                            // deleteIcon={true}
                                                        />
                                                    ) : (
                                                        <Chip
                                                            key={index}
                                                            label={tr(selecedOption.displayName)}
                                                            className="MuiChip-root setting-title"
                                                            onDelete={isEditMode ? (e => {
                                                                valueTag.length > 1
                                                                    ? handleDeleteEditPermission(selecedOption)
                                                                    : setIsOpenAlertDialog(true);
                                                            }) : undefined}
                                                        />
                                                    );
                                                });
                                            }}
                                            ListboxProps={{
                                                style: {
                                                    maxHeight: 376,
                                                    overflow: 'auto',
                                                    overflowX: 'hidden'
                                                }
                                            }}
                                            noOptionsText={trI18n('COMMSG001')}
                                        />
                                    </div>
                                </div>

                                {(isDisplayAdditionalPermission && !(isDisplaySettingSynonymSearch(corporationDetail, selectedFormDetail?.type || detailTicket?.usage, projectInuseDetail) && (detailTicket ? detailTicket?.isSynonym : selectedFormDetail?.isSynonym))) && (
                                    <>
                                        <div className="setting-permission-wrap">
                                            <label className="setting-permission-label">{tr('追加閲覧権限')}</label>
                                            <div className={`setting-permission-input ${disabled ? 'class_disabled': 'enable-autoComplete'}`}>
                                                <Autocomplete
                                                    className="setting-permission-tag-content"
                                                    multiple
                                                    disableClearable
                                                    filterSelectedOptions={true}
                                                    filterOptions={filterSuggestionForAdditionalPermission}
                                                    getOptionLabel={option =>
                                                        ` ${getAdditionalPermissionName(option)}`
                                                    }
                                                    getOptionSelected={(option, selected) =>
                                                        option.id === selected.id
                                                    }
                                                    options={filterCorporationBlockAndDelete(listOptionAdditionalViewPermission)}
                                                    value={additionalViewPermissions.filter(i => i && i?.name)}
                                                    groupBy={option => tr(option.groupLabel)}
                                                    onChange={onChangeAdditionalViewPermission}
                                                    disabled={disabled}
                                                    renderInput={params => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="form-control"
                                                        />
                                                    )}
                                                    noOptionsText={trI18n('COMMSG001')}
                                                    renderTags={valueTag => {
                                                        return valueTag.map((selectedOption, index) => {
                                                            if (selectedOption) {
                                                                return (
                                                                    <Chip
                                                                        className="MuiChip-root MuiAutocomplete-tag MuiChip-deletable"
                                                                        label={
                                                                            <OverFlowTooltipWithTabsMui
                                                                                value={getAdditionalPermissionName(
                                                                                    selectedOption
                                                                                )}
                                                                            />
                                                                        }
                                                                        onDelete={isEditMode ? () =>
                                                                            onDeleteAdditionalViewPermission(
                                                                                selectedOption
                                                                            )
                                                                        : undefined}
                                                                    />
                                                                );
                                                            }
                                                            
                                                        });
                                                    }}
                                                    renderOption={option => {
                                                        if (option && option?.name) {
                                                            return (<span
                                                                style={{
                                                                    overflow: 'hidden',
                                                                    whiteSpace: 'nowrap',
                                                                    textOverflow: 'ellipsis'
                                                                }}
                                                            >
                                                                <OverFlowTooltipWithTabsMui
                                                                    value={getAdditionalPermissionName(
                                                                        option
                                                                    )}
                                                                />
                                                            </span>)
                                                        }
                                                        
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="setting-permission-wrap">
                                            <label className="setting-permission-label">{tr('追加編集権限')}</label>
                                            <div className={`setting-permission-input ${disabled ? 'class_disabled': 'enable-autoComplete'}`}>
                                                <Autocomplete
                                                    className="setting-permission-tag-content"
                                                    multiple
                                                    disableClearable
                                                    filterSelectedOptions={true}
                                                    filterOptions={filterSuggestionForAdditionalPermission}
                                                    getOptionLabel={option =>
                                                        ` ${getAdditionalPermissionName(option)}`
                                                    }
                                                    getOptionSelected={(option, selected) =>
                                                        option.id === selected.id
                                                    }
                                                    options={getSortedOptionsByGroupLabel(listOptionAdditionalEditPermission)}
                                                    value={additionalEditPermissions}
                                                    groupBy={option => tr(option.groupLabel)}
                                                    onChange={onChangeAdditionalEditPermission}
                                                    disabled={disabled}
                                                    renderInput={params => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            className="form-control"
                                                        />
                                                    )}
                                                    noOptionsText={trI18n('COMMSG001')}
                                                    renderTags={valueTag => {
                                                        return valueTag.map((selectedOption, index) => {
                                                            if (selectedOption) {
                                                                return (
                                                                    <Chip
                                                                        className="MuiChip-root MuiAutocomplete-tag MuiChip-deletable"
                                                                        label={
                                                                            <OverFlowTooltipWithTabsMui
                                                                                value={getAdditionalPermissionName(
                                                                                    selectedOption
                                                                                )}
                                                                            />
                                                                        }
                                                                        onDelete={isEditMode ? () =>
                                                                            onDeleteAdditionalEditPermission(
                                                                                selectedOption
                                                                            )
                                                                        : undefined}
                                                                    />
                                                                );
                                                            }
                                                        });
                                                    }}
                                                    renderOption={option => {
                                                        if (option && !Utils.isEmptyObject(option)) {
                                                            return (<span
                                                                style={{
                                                                    overflow: 'hidden',
                                                                    whiteSpace: 'nowrap',
                                                                    textOverflow: 'ellipsis'
                                                                }}
                                                            >
                                                                <OverFlowTooltipWithTabsMui
                                                                    value={getAdditionalPermissionName(
                                                                        option
                                                                    )}
                                                                />
                                                            </span>)
                                                        }
                                                        
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* View-Edit Chat Permission Setting  */}
                            <div className={`${isShowSettingPermission ? 'setting-permission-body' : 'setting-permission-body-none'}`}>
                                <div className="setting-permission-title">
                                    {tr('■ チャットの閲覧・書き込み権限設定')}
                                </div>

                                <div className="setting-permission-wrap">
                                    <label className="setting-permission-label">{tr('基本権限')}</label>
                                    <div className={`setting-permission-input ${disabled ? 'class_disabled': 'enable-autoComplete'}`}>
                                        <TextField
                                            className="form-control--wrap form-control--hg40"
                                            select
                                            variant="outlined"
                                            name="publicRange"
                                            value={chatPermission}
                                            onChange={onChangeChatPermission}
                                            required
                                            disabled={disabled}
                                            SelectProps={{
                                                MenuProps: {
                                                    anchorOrigin: {
                                                        vertical: 'bottom',
                                                        horizontal: 'left'
                                                    },
                                                    getContentAnchorEl: null,
                                                    className: 'selectDrop'
                                                }
                                            }}
                                        >
                                            {!Utils.isEmptyArray(listOptionChatPermission) &&
                                                listOptionChatPermission?.map((item, i) => {
                                                    return (
                                                        <MenuItem key={i} value={item.value}>
                                                            {tr(item.displayName)}
                                                        </MenuItem>
                                                    );
                                                })}
                                        </TextField>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    <AlertDialog isOpen={isOpenAlertDialog} setIsOpen={setIsOpenAlertDialog} />
                </>
            ) : (
                <></>
            )}
        </>
    );
}

export default memo(SettingPermissionKnowledgeTicket)
